<template>
    <q-checkbox
        label="Allow marketing communication"
        outlined dense
        :model-value="modelValue"
        @update:modelValue="(value) => $emit('update:modelValue', value)"
    />
    <br>
</template>

<script>
export default {
    name: 'members-form-field-allow-marketing',
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style scoped>
</style>
